__turbopack_context__.v({
  "agendaCard": "ConferenceDetails-module-scss-module__Rqp3oa__agendaCard",
  "agendaContent": "ConferenceDetails-module-scss-module__Rqp3oa__agendaContent",
  "agendaGrid": "ConferenceDetails-module-scss-module__Rqp3oa__agendaGrid",
  "agendaHeader": "ConferenceDetails-module-scss-module__Rqp3oa__agendaHeader",
  "agendaItem": "ConferenceDetails-module-scss-module__Rqp3oa__agendaItem",
  "agendaList": "ConferenceDetails-module-scss-module__Rqp3oa__agendaList",
  "agendaSection": "ConferenceDetails-module-scss-module__Rqp3oa__agendaSection",
  "agendaTime": "ConferenceDetails-module-scss-module__Rqp3oa__agendaTime",
  "answerContent": "ConferenceDetails-module-scss-module__Rqp3oa__answerContent",
  "chevron": "ConferenceDetails-module-scss-module__Rqp3oa__chevron",
  "container": "ConferenceDetails-module-scss-module__Rqp3oa__container",
  "ctaBadge": "ConferenceDetails-module-scss-module__Rqp3oa__ctaBadge",
  "ctaButtons": "ConferenceDetails-module-scss-module__Rqp3oa__ctaButtons",
  "ctaContent": "ConferenceDetails-module-scss-module__Rqp3oa__ctaContent",
  "ctaDescription": "ConferenceDetails-module-scss-module__Rqp3oa__ctaDescription",
  "ctaNote": "ConferenceDetails-module-scss-module__Rqp3oa__ctaNote",
  "ctaSection": "ConferenceDetails-module-scss-module__Rqp3oa__ctaSection",
  "ctaTitle": "ConferenceDetails-module-scss-module__Rqp3oa__ctaTitle",
  "faqAnswer": "ConferenceDetails-module-scss-module__Rqp3oa__faqAnswer",
  "faqItem": "ConferenceDetails-module-scss-module__Rqp3oa__faqItem",
  "faqList": "ConferenceDetails-module-scss-module__Rqp3oa__faqList",
  "faqQuestion": "ConferenceDetails-module-scss-module__Rqp3oa__faqQuestion",
  "faqSection": "ConferenceDetails-module-scss-module__Rqp3oa__faqSection",
  "freeBadge": "ConferenceDetails-module-scss-module__Rqp3oa__freeBadge",
  "goalCard": "ConferenceDetails-module-scss-module__Rqp3oa__goalCard",
  "goalDescription": "ConferenceDetails-module-scss-module__Rqp3oa__goalDescription",
  "goalIcon": "ConferenceDetails-module-scss-module__Rqp3oa__goalIcon",
  "goalTag": "ConferenceDetails-module-scss-module__Rqp3oa__goalTag",
  "goalTitle": "ConferenceDetails-module-scss-module__Rqp3oa__goalTitle",
  "goalsGrid": "ConferenceDetails-module-scss-module__Rqp3oa__goalsGrid",
  "goalsSection": "ConferenceDetails-module-scss-module__Rqp3oa__goalsSection",
  "highlight": "ConferenceDetails-module-scss-module__Rqp3oa__highlight",
  "itemDot": "ConferenceDetails-module-scss-module__Rqp3oa__itemDot",
  "open": "ConferenceDetails-module-scss-module__Rqp3oa__open",
  "primaryButton": "ConferenceDetails-module-scss-module__Rqp3oa__primaryButton",
  "pulse": "ConferenceDetails-module-scss-module__Rqp3oa__pulse",
  "questionText": "ConferenceDetails-module-scss-module__Rqp3oa__questionText",
  "secondaryButton": "ConferenceDetails-module-scss-module__Rqp3oa__secondaryButton",
  "section": "ConferenceDetails-module-scss-module__Rqp3oa__section",
  "sectionHeader": "ConferenceDetails-module-scss-module__Rqp3oa__sectionHeader",
  "sectionSubtitle": "ConferenceDetails-module-scss-module__Rqp3oa__sectionSubtitle",
  "sectionTitle": "ConferenceDetails-module-scss-module__Rqp3oa__sectionTitle",
  "themeCard": "ConferenceDetails-module-scss-module__Rqp3oa__themeCard",
  "visible": "ConferenceDetails-module-scss-module__Rqp3oa__visible",
});
